import type { PluginWebManifest } from '@reflex/plugin-api/web';

export const codeReviewWeb: PluginWebManifest = {
  // code-review is a no-page plugin — it only contributes a "Review"
  // agent tab. The overview card is written by hand (rather than via
  // `definePage`, which would mint an unwanted route/nav-item) so the
  // plugin detail page renders a rich About section. `to` targets
  // the canonical plugin detail page since there is no standalone
  // page to deep-link to.
  overviewCards: [
    {
      to: '/org/plugins/code-review',
      label: 'Code Review',
      icon: 'MessageSquareCode',
      description: 'Inline code review for agent file changes.',
      details:
        'Open a Review tab on any agent to diff the files the agent has touched and leave inline comments. Comments are submitted back to the agent as part of the conversation so it can address feedback in the next turn.',
      features: [
        '"Review" tab on every agent detail page',
        'Searchable file tree with reviewed-file progress and visibility filters',
        'One-file and continuous all-files review modes',
        'Unified and split diffs with optional whitespace filtering',
        'Inline comments anchored to specific lines',
        'Comments are delivered to the agent as a follow-up turn',
      ],
      group: 'plugins',
    },
  ],
  agentTabs: [
    {
      id: 'code-review',
      label: 'Review',
      icon: 'MessageSquareCode',
      componentPath: '@reflex/plugin-code-review/web/ReviewTab',
    },
  ],
  // Chip in the agent stream header that flags review comments which have
  // been written but not yet submitted to the agent. Draft comments only
  // reach the agent on `POST /reviews/:id/submit`, so without this nudge a
  // user can leave feedback and assume the agent can see it when it cannot.
  // Clicking the chip opens the Review tab to submit.
  agentHeaderBadges: [
    {
      id: 'code-review-unsent',
      componentPath: '@reflex/plugin-code-review/web/ReviewSubmitChip',
    },
  ],
  marketingPreviews: [
    {
      id: 'code-review-panel',
      label: 'Code review agent panel',
      description:
        'How code review surfaces inside an agent — inline diff with sample changes and comments anchored to specific lines.',
      surface: 'panel',
      componentPath: '@reflex/plugin-code-review/web/ReviewTabPreview',
    },
  ],
};
